import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight, Trophy, TrendingUp, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 lg:pt-32 lg:pb-24 overflow-hidden bg-gradient-to-b from-gray-50 to-white" data-id="element-48">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-49">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-50">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col gap-6" data-id="element-51">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-[#FF6B35] w-fit font-medium text-sm" data-id="element-52">
              <span className="relative flex h-2 w-2" data-id="element-53">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75" data-id="element-54"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FF6B35]" data-id="element-55"></span>
              </span>
              Plataforma de Retenção Inteligente
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-[#2D3748]" data-id="element-56">
              Sistema de progresso e reconhecimento que{' '}
              <span className="text-[#FF6B35]" data-id="element-57">reduz o churn</span> da sua
              academia
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-xl" data-id="element-58">
              Transforme o esforço dos alunos em engajamento real, retenção
              automática e aumento de LTV — sem depender de personal individual.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4" data-id="element-59">
              <Button href="https://irongym.malbs.com.br/" size="lg" className="group" data-id="element-60">
                Visitar sistema
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-61" />
              </Button>
              <Button variant="secondary" size="lg" href="#how-it-works" data-id="element-62">
                Como funciona
              </Button>
            </div>

            <div className="flex items-center gap-6 mt-8 text-sm text-gray-500 font-medium" data-id="element-63">
              <div className="flex items-center gap-2" data-id="element-64">
                <Users className="h-4 w-4 text-[#FF6B35]" data-id="element-65" />
                <span data-id="element-66">+ Engajamento</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-67">
                <TrendingUp className="h-4 w-4 text-[#FF6B35]" data-id="element-68" />
                <span data-id="element-69">- Churn</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-70">
                <Trophy className="h-4 w-4 text-[#FF6B35]" data-id="element-71" />
                <span data-id="element-72">+ LTV</span>
              </div>
            </div>
          </motion.div>

          {/* Visual Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-73">
            <div className="relative z-10 bg-white rounded-2xl shadow-2xl border border-gray-100 p-2 overflow-hidden" data-id="element-74">
              {/* Abstract App UI Representation */}
              <div className="bg-gray-50 rounded-xl overflow-hidden aspect-[4/3] relative" data-id="element-75">
                {/* Header UI */}
                <div className="absolute top-0 left-0 right-0 h-16 bg-[#2D3748] flex items-center justify-between px-6" data-id="element-76">
                  <div className="w-24 h-4 bg-gray-600 rounded" data-id="element-77"></div>
                  <div className="w-8 h-8 bg-gray-600 rounded-full" data-id="element-78"></div>
                </div>

                {/* Dashboard Content */}
                <div className="absolute top-20 left-6 right-6 bottom-6 flex gap-4" data-id="element-79">
                  {/* Sidebar */}
                  <div className="w-16 hidden md:block bg-white rounded-lg shadow-sm h-full" data-id="element-80"></div>

                  {/* Main Area */}
                  <div className="flex-1 flex flex-col gap-4" data-id="element-81">
                    {/* Stats Row */}
                    <div className="flex gap-4" data-id="element-82">
                      <div className="flex-1 bg-white p-4 rounded-lg shadow-sm border-l-4 border-[#FF6B35]" data-id="element-83">
                        <div className="w-8 h-8 bg-orange-100 rounded mb-2" data-id="element-84"></div>
                        <div className="w-16 h-3 bg-gray-200 rounded mb-1" data-id="element-85"></div>
                        <div className="w-10 h-4 bg-gray-800 rounded" data-id="element-86"></div>
                      </div>
                      <div className="flex-1 bg-white p-4 rounded-lg shadow-sm" data-id="element-87">
                        <div className="w-8 h-8 bg-blue-100 rounded mb-2" data-id="element-88"></div>
                        <div className="w-16 h-3 bg-gray-200 rounded mb-1" data-id="element-89"></div>
                        <div className="w-10 h-4 bg-gray-800 rounded" data-id="element-90"></div>
                      </div>
                      <div className="flex-1 bg-white p-4 rounded-lg shadow-sm" data-id="element-91">
                        <div className="w-8 h-8 bg-green-100 rounded mb-2" data-id="element-92"></div>
                        <div className="w-16 h-3 bg-gray-200 rounded mb-1" data-id="element-93"></div>
                        <div className="w-10 h-4 bg-gray-800 rounded" data-id="element-94"></div>
                      </div>
                    </div>

                    {/* Chart Area */}
                    <div className="flex-1 bg-white p-4 rounded-lg shadow-sm flex flex-col" data-id="element-95">
                      <div className="flex justify-between mb-4" data-id="element-96">
                        <div className="w-32 h-4 bg-gray-200 rounded" data-id="element-97"></div>
                        <div className="w-16 h-4 bg-gray-100 rounded" data-id="element-98"></div>
                      </div>
                      <div className="flex-1 flex items-end justify-between gap-2 px-2" data-id="element-99">
                        {[40, 65, 45, 80, 55, 90, 70].map((h, i) => <div key={i} className="w-full bg-orange-100 rounded-t-sm relative group" data-id="element-100">
                            <div className="absolute bottom-0 left-0 right-0 bg-[#FF6B35] rounded-t-sm transition-all duration-1000" style={{
                          height: `${h}%`
                        }} data-id="element-101"></div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating Card Overlay */}
                <motion.div initial={{
                y: 20,
                opacity: 0
              }} animate={{
                y: 0,
                opacity: 1
              }} transition={{
                delay: 0.8,
                duration: 0.5
              }} className="absolute bottom-8 right-8 bg-white p-4 rounded-lg shadow-xl border border-gray-100 max-w-[200px]" data-id="element-102">
                  <div className="flex items-center gap-3 mb-2" data-id="element-103">
                    <div className="bg-yellow-100 p-1.5 rounded-full" data-id="element-104">
                      <Trophy className="h-4 w-4 text-yellow-600" data-id="element-105" />
                    </div>
                    <span className="font-bold text-sm text-gray-800" data-id="element-106">
                      Novo Recorde!
                    </span>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-107">
                    João completou 20 treinos este mês.
                  </p>
                </motion.div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" data-id="element-108"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" data-id="element-109"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}